import React from 'react'
import { Image, Platform, StyleSheet, View } from 'react-native'
import moment from 'moment'

import { CustomText } from '../text/StyledText'
import IconNames from '../../constants/IconNames'
import NormalIcon from '../../components/icons/NormalIcon'

import Paths from '../../constants/Paths'
import Colors from '../../constants/Colors'
import Fontsizes from '../../constants/Fontsizes'
import { cardShadow } from '../../styles/shadows'
import { CornerStyles } from '../../styles'
import { txt } from '../../locales/i18n'
import CustomPressable from "../pressables/CustomPressable"
import * as Linking from "expo-linking"
import { generateUUID } from "../../services/api/User"

export const EventListItem = ({ event, navigateToEvent }) => {
  const isPlusMemberEvent = event?.plusMembersOnly ?? false

  const handleOpenLink = async () => {
    const uuid = await generateUUID()

    const url = `${event.bookingLink}?plusMember=${uuid}`

    if (Platform.OS === 'web') {
      window.open(url, '_blank')
    } else await Linking.openURL(url)
  }

  return (
    <View style={styles.eventContainer}>
      <CustomPressable
        accessibilityHint={txt('events.eventListItemHint')}
        accessibilityLabel={txt('events.eventListItemLabel')}
        accessibilityRole="button"
        style={[styles.eventCard, isPlusMemberEvent && { borderWidth: 2, borderColor: Colors.orange}]}
        onPress={isPlusMemberEvent ? handleOpenLink : navigateToEvent}
      >
        <View style={styles.topContainer}>
          <Image
            accessibilityIgnoresInvertColors
            style={styles.cover}
            source={{ uri: Paths.imageEventUrlBase + event.imageSource }}
          />

          <View style={styles.textContainer}>
            <CustomText font="smallBold" style={styles.title} numberOfLines={2}>
              {event.title}
            </CustomText>

            {isPlusMemberEvent && <View style={{width: 75, height: 2, backgroundColor: Colors.orange, marginTop: 0, marginBottom: 12}}/>}

            <CustomText font="small" numberOfLines={3}>
              {event.body}
            </CustomText>
          </View>
        </View>


        {isPlusMemberEvent ? (
          <View style={[styles.bottomContainer, { borderTopColor: 'rgba(239, 143, 73, 0.14)' }]}>
            <View style={styles.detailContainer}>
              <CustomText font="smallBold" style={[styles.datailText, { color: Colors.orange }]}>{txt('events.plusMember')}</CustomText>
            </View>

            <View style={styles.detailContainer}>
              <CustomText font="smallBold" style={[styles.datailText, { color: Colors.orange }]}>
                {txt('events.plusMemberPrice', { price: event.price})}
              </CustomText>
            </View>
          </View>
        ) : (
          <View style={styles.bottomContainer}>
            <View style={styles.detailContainer}>
              <NormalIcon stroke="fad" size={Fontsizes.m} name={IconNames.calendarDay} color={Colors.blueAzure} />
              <CustomText font="small" style={styles.datailText}>{moment(event.dateStart).format('LL')}</CustomText>
            </View>

            <View style={styles.detailContainer}>
              <NormalIcon stroke="fad" size={Fontsizes.m} name={IconNames.mapMarker} color={Colors.blueAzure} />
              <CustomText font="small" style={styles.datailText}>
                {event.postalCode}, {event.city}
              </CustomText>
            </View>
          </View>
        )}


      </CustomPressable>
    </View>
  )
}

const styles = StyleSheet.create({
  eventContainer: {
    width: '100%',
    paddingHorizontal: 12,
    paddingVertical: 6,
  },

  eventCard: {
    backgroundColor: Colors.white,
    ...CornerStyles.borderRadiusS,
    ...cardShadow,
  },

  cover: {
    borderRadius: 12,
    height: 100,
    width: 100,
    margin: 12,
  },

  textContainer: {
    margin: 12,
    flex: 1,
  },

  title: {
    marginVertical: 6,
  },

  topContainer: {
    flexDirection: 'row',
    width: '100%',
  },

  bottomContainer: {
    borderTopColor: Colors.greyLightLight,
    borderTopWidth: 2,
    padding: 8,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    overflow: 'hidden',
    flexWrap: 'wrap',
  },

  detailContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },

  datailText: {
    marginLeft: 6,
  },
})
